import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {UntypedFormArray, UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, AbstractControl} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {UserDirectoryService} from '../services/user-directory.service';
import {UserSearchRequest} from '../model/user-search-request.model';
import { AllUsersSearchRequest } from '../model/all-users-search-request.model';
import * as $ from 'jquery';
import cloneDeep from 'lodash-es/cloneDeep';
import { EdlPortalUserSearchCriteria } from '../model/edl-portal-user-search-criteria.model';
import { ApplicationRoles, Building, Group, PortalRole, PortalRoleGroup, User } from '@edl-development/edl-common';

@Component({
    selector: 'edl-modal-user-directory',
    templateUrl: './edl-modal-user-directory.component.html',
    styleUrls: ['./edl-modal-user-directory.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class EdlModalUserDirectory implements OnInit {
    @Input() users: UntypedFormArray;
    @Input() portalId: number;
    @Input() singleUser: boolean;
    @Input() searchType: number;
    @Input() AccessRoles: number[];
    @Input() Groups: Group[];
    @Input() PortalRoleNames: string[];

    RoleGroups: PortalRoleGroup[];
    buildingOptions: UntypedFormArray;
    buildings: UntypedFormArray;

    groupOptions: UntypedFormArray;
    groups: UntypedFormArray;

    roleOptions: { label: string, value: UntypedFormArray }[];
    roles: UntypedFormArray;

    userSearchOptions: { Key: string, Value: String }[];

    searchForm: UntypedFormGroup;

    busy: boolean;
    searchOptions: any;
    searchResults: UntypedFormArray;
    selectedUsers: UntypedFormArray;

    listFilter: string;

    constructor(
        public activeModal: NgbActiveModal,
        private userDirectoryService: UserDirectoryService,
        private formBuilder: UntypedFormBuilder
    ) {}

    ngOnInit() {
        this.busy = false;
        this.searchResults = new UntypedFormArray([]);
        this.selectedUsers = cloneDeep(this.users);

        this.buildingOptions = new UntypedFormArray([]);
        this.buildings = new UntypedFormArray([]);

        this.groupOptions = new UntypedFormArray([]);
        this.groups = new UntypedFormArray([]);

        this.roleOptions = [];
        this.roles = new UntypedFormArray([]);

        if(!this.searchType) this.searchType = 0;
        if(!this.AccessRoles) {
            this.AccessRoles = [];
            this.AccessRoles.push(ApplicationRoles.USER);
            this.AccessRoles.push(ApplicationRoles.LIMITED_SUPERVISOR);
            this.AccessRoles.push(ApplicationRoles.SUPERVISOR);
            this.AccessRoles.push(ApplicationRoles.ADMIN);
            this.AccessRoles.push(ApplicationRoles.EDLADMIN);
        }

        this.searchForm = this.formBuilder.group({
            PortalId: [this.portalId, []],
            SearchType: [this.searchType, []],
            UserSearchProperty: ['', []],
            PortalBuildings: this.buildings,
            PortalGroups: this.groups,
            PortalRoles: this.roles
        });

        this.userDirectoryService
            .getSearchCriteria(this.portalId)
            .subscribe((results: EdlPortalUserSearchCriteria) => {
                this.searchOptions = results;
                this.buildForm();
                
            }, error => {
                // TODO: Handle Error
            });
    }

    buildForm() {
        this.buildingOptions = new UntypedFormArray([]);
        this.groupOptions = new UntypedFormArray([]);
        this.roleOptions = [];
        
        let results = this.searchOptions;
        results.PortalBuildings.map((building: Building) => {
            this.buildingOptions.push(new UntypedFormControl({
                name: building.BuildingName,
                value: new UntypedFormControl(building),
                isChecked: false
            }));
        });

        const PortalGroups = this.Groups ? this.Groups : results.PortalGroups;
        PortalGroups.map((group: Group) => {
            this.groupOptions.push(new UntypedFormControl({
                name: group.GroupName,
                value: new UntypedFormControl(group),
                isChecked: false
            }));
        });

        this.RoleGroups = this.PortalRoleNames ? this.filterRoleGroupsByRoleNames(results.PortalRoles, this.PortalRoleNames) : null;

        const PortalRoles = this.RoleGroups ? this.RoleGroups : results.PortalRoles;
        PortalRoles.map((portalRoleGroup: PortalRoleGroup) => {
            let roles: UntypedFormArray = new UntypedFormArray([]);

            portalRoleGroup.Roles.map((portalRole: PortalRole) => {
                roles.push(new UntypedFormControl({
                    name: portalRole.RoleName,
                    value: new UntypedFormControl(portalRole),
                    isChecked: false
                }));
            });

            this.roleOptions.push({
                label: portalRoleGroup.GroupName,
                value: roles
            });
        });
        this.userSearchOptions = results.UserSearchOptions;

    }

    onSubmit({ value, valid }: { value: UserSearchRequest, valid: boolean }) {
        this.busy = true;
        $("body").toggleClass("busy");        
        value.AccessRoles = this.AccessRoles;

        if (this.Groups && (!value.PortalGroups || value.PortalGroups.length === 0)) {
            value.PortalGroups = this.Groups;
        }

        if (this.RoleGroups && (!value.PortalRoles || value.PortalRoles.length === 0)) {
            value.PortalRoles = this.getRolesFromRoleGroups(this.RoleGroups);
        }

        this.userDirectoryService
            .search(value)
            .subscribe((results: User[]) => {
                this.searchResults = new UntypedFormArray([]);

                results.map((user: User) => {
                    let userInResults:boolean = false;
                    for ( let x in this.selectedUsers.controls ) {
                        if( user.UserID === this.selectedUsers.controls[ x ].value.UserID ) {
                            userInResults = true;
                        }
                    }
                    if (!userInResults) {
                        this.searchResults.push(new UntypedFormControl(user));
                    }
                });
                $("body").toggleClass("busy");
                this.busy = false;
            });
            
    }

    getAllUsers(){
        this.busy = true;
        $("body").toggleClass("busy");   
        
        const searchRequest = new AllUsersSearchRequest();
        searchRequest.AccessRoles = this.AccessRoles;
        searchRequest.PortalGroups = this.Groups;
        searchRequest.PortalRoles = this.RoleGroups ? this.getRolesFromRoleGroups(this.RoleGroups) : null;

        this.userDirectoryService
            .getAllUsers(this.searchType, searchRequest)
            .subscribe((results: User[]) => {
                this.searchResults = new UntypedFormArray([]);

                results.map((user: User) => {
                    let userInResults:boolean = false;
                    for ( let x in this.selectedUsers.controls ) {
                        if( user.UserID === this.selectedUsers.controls[ x ].value.UserID ) {
                            userInResults = true;
                        }
                    }
                    if (!userInResults) {
                        this.searchResults.push(new UntypedFormControl(user));
                    }
                });
                $("body").toggleClass("busy");
                this.busy = false;
            });

    }

    filterRoleGroupsByRoleNames = (roleGroups: PortalRoleGroup[], RoleNames: string[]) : PortalRoleGroup[] => {
        return roleGroups.reduce((filteredPortalRoleGroups: PortalRoleGroup[], portalRoleGroup: PortalRoleGroup) => {
            if (portalRoleGroup.Roles) {
                const filteredRoles = portalRoleGroup.Roles.filter((portalRole: PortalRole) => RoleNames.indexOf(portalRole.RoleName) !== -1);
                if (filteredRoles.length > 0) {
                    const portalRoleGroupCopy = Object.assign({}, portalRoleGroup);
                    portalRoleGroupCopy.Roles = filteredRoles;
                    filteredPortalRoleGroups.push(portalRoleGroupCopy)
                }
            }

            return filteredPortalRoleGroups;
        }, []);
    }

    getRolesFromRoleGroups = (roleGroups: PortalRoleGroup[]) : PortalRole[] => {
        return roleGroups.reduce((portalRoles: PortalRole[], portalRoleGroup: PortalRoleGroup) => {
                if (portalRoleGroup.Roles) {
                    portalRoles.push(...portalRoleGroup.Roles);
                }
                return portalRoles;
            }, []);
    }

    onSelectUser(user: UntypedFormControl) {
        if (this.singleUser && this.selectedUsers.length > 0) {
            return;
        }

        let index: number = this.searchResults.controls.indexOf(user);
        let selected: AbstractControl = this.searchResults.at(index);
        let userInResults:boolean =false;

        // look for same user object in selectedUsers
        for( let u in this.selectedUsers.controls ) {
            if( this.selectedUsers.controls[ u ].value.UserID === user.value.UserID ) {
                userInResults = true;
            }
        }   

        if (selected && !userInResults) {
            this.searchResults.removeAt(index);
            this.selectedUsers.push(selected);

            var sotedValues = this.selectedUsers.value.sort(this.alphaSort);
            this.selectedUsers.patchValue(sotedValues);

        }
    }

    onSelectAllUsers() {
        while (this.searchResults.controls.length > 0) {
            let selected: AbstractControl = this.searchResults.at(0);

            this.searchResults.removeAt(0);
            this.selectedUsers.push(selected);
        }
    }

    alphaSort(a, b){
        if(a.LastName < b.LastName) return -1;
        if(a.LastName > b.LastName) return 1;
        return 0;
    }

    onRemoveUser(user: UntypedFormControl) {
        let index: number = this.selectedUsers.controls.indexOf(user);
        let selected: AbstractControl = this.selectedUsers.at(index);

        this.selectedUsers.removeAt(index);

        if (selected) {
            this.searchResults.push(selected);
        }
    }

    onRemoveAllUsers() {
        while (this.selectedUsers.controls.length > 0) {
            let selected: AbstractControl = this.selectedUsers.at(0);

            this.selectedUsers.removeAt(0);
            this.searchResults.push(selected);
        }
    }

    onResetSearch() {
        this.searchForm.reset();
        
        this.buildForm();
        
        while (this.buildings.controls.length > 0) {
            this.buildings.removeAt(0);
        }
        while (this.roles.controls.length > 0) {
            this.roles.removeAt(0);
        }
        while (this.groups.controls.length > 0) {
            this.groups.removeAt(0);
        }

        this.searchForm = this.formBuilder.group({
            PortalId: [this.portalId, []],
            UserSearchProperty: ['', []],
            PortalBuildings: this.buildings,
            PortalGroups: this.groups,
            PortalRoles: this.roles
        });
        
        this.onSubmit(this.searchForm);
    }
}
